import { lazy } from "react";

const DaftarPengguna = lazy(() => import("./Daftar"));
const EditPengguna = lazy(() => import("./Edit"));
const EditPassword = lazy(() => import("./Edit-Password"));

export { DaftarPengguna, EditPengguna, EditPassword };
